module.exports = __webpack_public_path__ + "img/new_style_icon.1604c4c3.png";